(function(angular) {
	'use strict';

	var core = angular.module('Core');

	/*
	 * User service
	 */
	core.service('UserService', ['$log', '$rootScope', '$q', function($log, $rootScope, $q) {
			var self = this;
			var deferred = $q.defer();
			this.userDetails = {
				userName: 'anonymous'
			};
			this.userData = {};

			this.getPromise = function() {
				return deferred.promise;
			};
			/**
			 * User details object (must contains following fields):
			 * {
			 *		userName: (String) login of the user
			 *		lastName: (Option String) name of the user
			 *		firstName: (Option String) first name of the user
			 * }
			 *
			 * @param {UserDetail} userDetails the detailed info of the user
			 */
			this.setUserDetails = function(userDetails) {
				if (!userDetails) {
					$log.error('UserService: The userDetails are null !');
					return;
				}
				if (!userDetails.userName) {
					$log.error('UserService: The userDetails must contain a userName !');
					return;
				}
				this.userDetails = userDetails;
				$log.debug('UserService: New user details (login: ' + this.userDetails.login + ')');

				$rootScope.$broadcast('user-details-initialized');
				deferred.resolve(userDetails);
			};

			this.getUserName = function() {
				return this.userDetails.userName;
			};

			this.getUserEmail = function() {
				return this.userDetails.email;
			};

			/**
			 * Get the user name and firstname
			 * @returns {String} name + first name or userName when no name / first name
			 */
			this.getUserNameFirstName = function() {
				var name = '';
				if (!this.userDetails.lastName && !this.userDetails.firstName) {
					name = this.getUserName();
				} else if (this.userDetails.lastName && this.userDetails.firstName) {
					name = this.userDetails.lastName + this.userDetails.firstName;
				} else {
					name = this.userDetails.lastName;
				}
				return name;
			};

			this.hasRole = function(role) {
				return self.userDetails.personneRoleIdsMap && self.userDetails.personneRoleIdsMap[role];
			};

			this.getIdForRole = function(role) {
				if (self.userDetails.personneRoleIdsMap && self.userDetails.personneRoleIdsMap[role]) {
					return self.userDetails.personneRoleIdsMap[role];
				}
				return null;
			};

			/**
			 * Attach data to the current user
			 * @param {Object} userData the data of the user
			 */
			this.setUserData = function(userData) {
				this.userData = userData;
			};

			/**
			 * Get the user data
			 * @returns {Object} the user data
			 */
			this.getUserData = function() {
				return this.userData;
			};
		}]);
})(angular);